import { Box, Checkbox, Grid, Group, Image } from "@mantine/core";
import { paymentMethodTilesAdminProps } from "../../../../types/types";

export function PaymentMethodTilesAdmin(props: paymentMethodTilesAdminProps) {
    
    return (
      <Grid.Col
        sx={() => ({
          paddingBottom: "20px",
        })}
        key={props.name}
        md={6}
        lg={3}
        sm={12}
      >
        <Box 
          sx={(theme) => ({
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid",
            padding: "30px",
            marginRight: "10px",
            boxShadow: "-1px 1px 6px -1px #d1cfcf",
            height: "100%",
            borderRadius: theme.radius.sm,
            borderColor: theme.colors.gray[4],
          })}
        >
          <Group>
            <Image width={35} height={35} src={props.image} />
          </Group>
          <Group
            sx={() => ({ 
                width: "65%",
                textAlign: "center",
                justifyContent: "center",
            })}>
            {props.name}
          </Group>
          

          <Group grow>
            <Checkbox
              sx={() => ({
                border: "1px solid #7DE5ED",
                borderRadius: "3px",
              })}
              styles={{ input: { border: "0px solid" }}}
              size="md"
              radius="xs"
            //   disabled = {props.disabled}
              checked={ props.metaDataBankList.some((ele:any) => ele.paymentServiceProvider === props.id && ele.isEnabled === 'false')}

              onChange={(event) => {
                let copyOfMetaData = [...props.metaDataBankList];
                copyOfMetaData.forEach((ele : any) => {
                  if(ele.paymentServiceProvider === props.id) {
                    if(ele.isEnabled === 'true') ele.isEnabled = 'false';
                    else ele.isEnabled = 'true'
                  };
                })
                props.setMetaData(copyOfMetaData)
              }}
            ></Checkbox>
          </Group>
        </Box>
      </Grid.Col>
    );
  }